import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useEffect, useState } from "react";
import { auth } from "../api/firebase";
import ModalForm from "./ModalForm";

export default function DotClickMenuAtPost({ post, onHidden }) {
  const [isAuthor, setIsAuthor] = useState(false);

  useEffect(() => {
    if (post?.creator === auth.currentUser?.uid) setIsAuthor(true);
  }, [post?.creator]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // ModalFormで使用
  const [openModal, setOpen] = useState(false);
  const [form, setForm] = useState("");
  const [requestId, setRequestId] = useState("");

  const handleEdit = (formName, id) => {
    setOpen(true);
    setForm(formName);
    setRequestId(id);
  };

  return (
    <>
      <ModalForm
        form={form}
        setOpen={setOpen}
        open={openModal}
        requestId={requestId}
        target={post}
        // ★FeedPrivate が成功したら投稿を消す
        onDone={() => {
          onHidden?.();
        }}
      />

      <div>
        <MoreHorizIcon
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        />

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
            onClick: handleClose, // ★メニュー内クリックで閉じる（開きっぱなし防止）
          }}
        >
          <MenuItem
            onClick={() => {
              handleClose(); // ★先に閉じる（確実）
              handleEdit("feedPrivate", post?.id);
            }}
          >
            <div className="flex flex-col space-y-0">
              <div>非公開にする</div>
              <div className="text-xs text-gray-400">Feedから非公開にします。</div>
            </div>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleClose(); // ★先に閉じる（確実）
              handleEdit("editPostMessage", post?.id);
            }}
          >
            <div className="flex flex-col space-y-0">
              <div>編集する</div>
              <div className="text-xs text-gray-400">投稿テキストを編集します。</div>
            </div>
          </MenuItem>
        </Menu>
      </div>
    </>
  );
}
